import React from 'react';
import { useSelector } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { makeStyles, useTheme, fade } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Menu from '@material-ui/core/Menu';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import MenuItem from '@material-ui/core/MenuItem';
import Divider from '@material-ui/core/Divider';
import Avatar from '@material-ui/core/Avatar';
import MenuIcon from '@material-ui/icons/Menu';
import PersonIcon from '@material-ui/icons/Person';
import { ReactComponent as IconChat } from 'assets/icons/video.svg';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import {
  usePopupState,
  bindTrigger,
  bindMenu,
} from 'material-ui-popup-state/hooks';
import { StudentSidebar } from 'constant';
import NotificationMenu from 'components/pages/notification/NotificationMenu';
import Chat from 'modules/student/chat';
import { useMediaQuery } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(2),
      backgroundColor: theme.palette.background.paper,
    },
  },
  toolbar: {
    minHeight: 72,
  },
  menuButton: {
    'marginRight': theme.spacing(2),
    'backgroundColor': theme.palette.primary.main,
    'color': theme.palette.primary.contrastText,
    'borderRadius': 0,
    'padding': theme.spacing(1),
    '&:hover': {
      backgroundColor: fade(theme.palette.primary.main, 0.8),
    },
  },
  title: {
    flexGrow: 1,
    fontSize: 32,
  },
  rightMenu: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: 'auto',
  },
  chat: {
    marginRight: 24,
    lineHeight: 0,
  },
  menuItem: {
    paddingTop: 8,
    paddingBottom: 8,
  },
  avatar: {
    backgroundColor: 'white',
    border: '3px solid #E9ECF1',
    width: 42,
    height: 42,
  },
  videocam: {
    '& path': {
      opacity: 0.5,
    },
  },
}));

const Header = ({
  routes,
  location,
  showChat,
  toggleChat,
  toggleMenu,
  dropdownItems,
  meetingUrl,
  showNotifications,
  renderTitle,
  isMeetingEnable,
}) => {
  const name = routes.find((i) =>
    i.url === '/'
      ? location.pathname === i.url
      : location.pathname.startsWith(i.url),
  )?.title;
  const classes = useStyles();
  const user = useSelector((s) => s.user.user);
  const popupState = usePopupState({ variant: 'popover', popupId: 'profile' });
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('sm'));

  const pageTitle = renderTitle ? renderTitle(name) : name;

  return (
    <Box>
      <AppBar
        position="static"
        className={classes.root}
        color="transparent"
        elevation={0}
      >
        <Toolbar className={classes.toolbar}>
          {matches && (
            <IconButton onClick={toggleMenu} className={classes.menuButton}>
              <MenuIcon />
            </IconButton>
          )}
          {!matches && (
            <Typography variant="h4" className={classes.title}>
              {pageTitle}
            </Typography>
          )}
          <div className={classes.rightMenu}>
            {toggleChat && <Chat show={showChat} toggle={toggleChat} />}
            {meetingUrl && isMeetingEnable && (
              <IconButton component={Link} to={meetingUrl}>
                <IconChat className={classes.videocam} />
              </IconButton>
            )}
            {showNotifications && <NotificationMenu user={user} />}
            <Avatar
              {...bindTrigger(popupState)}
              src={user.user_pic}
              className={classes.avatar}
            >
              <PersonIcon />
            </Avatar>
            <Menu
              {...bindMenu(popupState)}
              getContentAnchorEl={null}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
              transformOrigin={{ vertical: 'top', horizontal: 'left' }}
            >
              {dropdownItems.map((i, idx) => (
                <MenuItem
                  key={idx}
                  component={Link}
                  to={i.to}
                  className={classes.menuItem}
                  onClick={popupState.close}
                >
                  {i.label}
                </MenuItem>
              ))}
              <Divider />
              <MenuItem
                component={Link}
                to="/logout"
                className={classes.menuItem}
                onClick={popupState.close}
                style={{ color: '#D76E6E' }}
              >
                <ExitToAppIcon
                  color="inherit"
                  fontSize="small"
                  style={{ marginRight: 8 }}
                />
                Log Out
              </MenuItem>
            </Menu>
          </div>
        </Toolbar>
      </AppBar>
      {matches && (
        <Box paddingX={2}>
          <Typography variant="h4" className={classes.title}>
            {pageTitle}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default withRouter(Header);
